import React from "react";
import { ErrorMessage, Field } from "formik";
import { Flex } from "../../../Flex";
import { FormInputErrorMessage } from "../../../FormInputErrorMessage";
import { FormikInputText } from "../../../FormikInputText";

interface Props {
  id: string;
}

export const DisconnectionDetailsOtherInfo: React.FC<Props> = ({ id }) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.7}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
    >
      <Field
        id={"disconnectionDetails.otherInformation"}
        name={"disconnectionDetails.otherInformation"}
        label="Any other information"
        optional
        component={FormikInputText}
      />
      <ErrorMessage
        name="disconnectionDetails.otherInformation"
        className="field-error"
        component={FormInputErrorMessage}
      />
    </Flex>
  );
};
